import { combineReducers } from "redux";
import { authReducer } from "./auth";
import { dashboardReducer } from "./dashboard";
import { usersReducer } from "./usersReudcer";
import { generalReducer } from "./generalReducer";
export const rootReducer = combineReducers({
  authReducer, dashboardReducer, usersReducer, generalReducer
});
